import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import ReRenderOnMount from 'components/consumer/ReRenderOnMount';
import PDPShopTabsBarUI from './PDPShopTabsBarUI';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPShopTabsBarPlaceholder from './PDPShopTabsBarPlaceholder';
const PDPShopTabsBarInner = t0 => {
  const $ = _c(38);
  const {
    isEditOrder: t1,
    hideDecideLaterTab: t2,
    isLayoutRevamp: t3
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const hideDecideLaterTab = t2 === undefined ? false : t2;
  const isLayoutRevamp = t3 === undefined ? false : t3;
  const {
    loading: optionsLoading,
    data: t4
  } = usePDPOptions();
  const {
    stock,
    options,
    upholsteryOptionId,
    hasSingleOptionType
  } = t4;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    loading: availabilityLoading,
    data: t5
  } = usePDPStockAvailability();
  const {
    isEFGInternal,
    isMarkedOOSOrDiscontinued,
    isDiscontinued,
    isOutOfStock,
    isStockLoading
  } = t5;
  const price = basicDetails?.meta?.price;
  const shouldShowReadyToShip = stock?.showReadyToShip && !basicDetails?.bypass_stock;
  let t6;
  if ($[0] !== availabilityLoading || $[1] !== hasSingleOptionType || $[2] !== isDiscontinued || $[3] !== isEFGInternal || $[4] !== isMarkedOOSOrDiscontinued || $[5] !== isOutOfStock || $[6] !== options || $[7] !== optionsLoading) {
    t6 = !availabilityLoading && !optionsLoading && (isEmpty(options) || isMarkedOOSOrDiscontinued && !isOutOfStock && !isDiscontinued || isEFGInternal && hasSingleOptionType);
    $[0] = availabilityLoading;
    $[1] = hasSingleOptionType;
    $[2] = isDiscontinued;
    $[3] = isEFGInternal;
    $[4] = isMarkedOOSOrDiscontinued;
    $[5] = isOutOfStock;
    $[6] = options;
    $[7] = optionsLoading;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const hideShopsTabBar = !!t6;
  let t7;
  if ($[9] !== availabilityLoading || $[10] !== isDiscontinued || $[11] !== isEFGInternal || $[12] !== isMarkedOOSOrDiscontinued || $[13] !== isOutOfStock || $[14] !== options || $[15] !== optionsLoading || $[16] !== pdpSelectedCustomizerTab || $[17] !== setPdpSelectedCustomizerTab) {
    t7 = () => {
      if (availabilityLoading || optionsLoading || isEmpty(options)) {
        return;
      }
      if (isMarkedOOSOrDiscontinued && !isOutOfStock && !isDiscontinued || isEFGInternal && pdpSelectedCustomizerTab !== PDP_READYTOSHIP_TAB_ID) {
        setPdpSelectedCustomizerTab(PDP_READYTOSHIP_TAB_ID);
      }
    };
    $[9] = availabilityLoading;
    $[10] = isDiscontinued;
    $[11] = isEFGInternal;
    $[12] = isMarkedOOSOrDiscontinued;
    $[13] = isOutOfStock;
    $[14] = options;
    $[15] = optionsLoading;
    $[16] = pdpSelectedCustomizerTab;
    $[17] = setPdpSelectedCustomizerTab;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== availabilityLoading || $[20] !== hasSingleOptionType || $[21] !== isDiscontinued || $[22] !== isEFGInternal || $[23] !== isMarkedOOSOrDiscontinued || $[24] !== isOutOfStock || $[25] !== options || $[26] !== optionsLoading || $[27] !== pdpSelectedCustomizerTab || $[28] !== setPdpSelectedCustomizerTab) {
    t8 = [availabilityLoading, hasSingleOptionType, isDiscontinued, isEFGInternal, isMarkedOOSOrDiscontinued, isOutOfStock, options, optionsLoading, pdpSelectedCustomizerTab, setPdpSelectedCustomizerTab];
    $[19] = availabilityLoading;
    $[20] = hasSingleOptionType;
    $[21] = isDiscontinued;
    $[22] = isEFGInternal;
    $[23] = isMarkedOOSOrDiscontinued;
    $[24] = isOutOfStock;
    $[25] = options;
    $[26] = optionsLoading;
    $[27] = pdpSelectedCustomizerTab;
    $[28] = setPdpSelectedCustomizerTab;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  useEffect(t7, t8);
  const t9 = optionsLoading || isMarkedOOSOrDiscontinued && isStockLoading;
  const t10 = !hideDecideLaterTab && !isEditOrder && !!upholsteryOptionId;
  let t11;
  if ($[30] !== hideShopsTabBar || $[31] !== isEFGInternal || $[32] !== isLayoutRevamp || $[33] !== price || $[34] !== shouldShowReadyToShip || $[35] !== t10 || $[36] !== t9) {
    t11 = <PDPShopTabsBarUI hideShopsTabBar={hideShopsTabBar} isEFGInternal={isEFGInternal} loading={t9} price={price} showDecideLater={t10} showReadyToShip={shouldShowReadyToShip} isLayoutRevamp={isLayoutRevamp} />;
    $[30] = hideShopsTabBar;
    $[31] = isEFGInternal;
    $[32] = isLayoutRevamp;
    $[33] = price;
    $[34] = shouldShowReadyToShip;
    $[35] = t10;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};
PDPShopTabsBarInner.propTypes = {
  isEditOrder: PropTypes.bool,
  // The layout revamp moves Decide Later out of the tab bar into a button
  hideDecideLaterTab: PropTypes.bool,
  isLayoutRevamp: PropTypes.bool
};
const PDPShopTabsBar = props => {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.isLayoutRevamp) {
    t0 = <PDPShopTabsBarPlaceholder isLayoutRevamp={props.isLayoutRevamp} />;
    $[0] = props.isLayoutRevamp;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <PDPShopTabsBarInner {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <ReRenderOnMount><SuspenseWithLoader fallback={t0}>{t1}</SuspenseWithLoader></ReRenderOnMount>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default PDPShopTabsBar;